export const getTime = (hour?: number, minute?: number) => {
  if (hour === undefined) return undefined;

  const today = new Date();
  today.setHours(hour, minute || 0, 0, 0);
  return today;
};
